/**
 * Background Visual
 *
 * @author Space-Time Inc.
 * @version 2022-07-25
 */

const wrap     = document.querySelector('.page-template-front-page .loading-wrap');
const visual    = document.querySelector('.page-template-front-page .part-top-visual');
const skip = document.querySelector(".page-template-front-page .skip");
const agent = window.navigator.userAgent.toLowerCase()

window.addEventListener('DOMContentLoaded', () => {
	
	var params_open = {
		container: document.getElementById('loading-anime'),
		renderer: "svg",
		loop: false,
		autoplay: false,
		path     : TOP_VISUAL.asset_url + 'lottie/animation-1.json',
	}
	var opening = lottie.loadAnimation(params_open);

	var params= {
		container: document.getElementById('top-visual-anime'),
		renderer: "svg",
		loop: true,
		autoplay: false,
		path     : TOP_VISUAL.asset_url + 'lottie/animation-top.json',
	}
	var animation = lottie.loadAnimation(params);

	if (!sessionStorage.getItem('disp')) {
		// if(visual) {
		// 	visual.classList.add('bg');
		// }
		window.addEventListener('load', function () {
			
			//setTimeout( loaderDisplay, 1000);
			// console.log(visual);
			if (agent.indexOf('safari') !== -1 && agent.indexOf('chrome') === -1){
				opening.setSpeed(0.5);
				//opening.setQuality('medium');
				setTimeout( loading_start, 2000);
				// console.log('Safariブラウザです');
				opening.onComplete = () => {
					// 任意の処理を記述する
					Eraselayer();
					animation_start();
				  }
				setTimeout( loaderDisplay3, 18000);
				skip.addEventListener("click", () => {
					opening.destroy();
					Eraselayer();
					animation.play();
				});
			} else {
				// console.log(visual);
				// setTimeout( loaderDisplay2, 3000);
				// console.log('safari');
				opening.play();
				// console.log('Safariブラウザではありません');
				opening.onComplete = () => {
					// 任意の処理を記述する
					Eraselayer();
					animation_start();
				  }
				setTimeout( loaderDisplay3, 9000);
				skip.addEventListener("click", () => {
					opening.destroy();
					Eraselayer();
					animation.play();
				});
			}
		}, false);
		sessionStorage.setItem('disp', 'on');
	 } else {
		if(wrap) {
			wrap.classList.add('hide');
			wrap.style.display= "none";
		}
		animation.play();
		setTimeout( loaderDisplay3, 3000);
	}

	function loading_start() {
		opening.play();
	}
	function animation_start() {
		animation.play();
	}
	function loaderDisplay () {
		if(wrap) {
		   wrap.classList.remove('active');
		   wrap.style.transition = "all .3s ease;"
		   //wrap.classList.add('hide');
		}
	 }
	function Eraselayer() {
		if(wrap) {
			wrap.classList.add('hide');
			setTimeout( Displaynone, 500);
			//wrap.style.display = "none"; 
		}
		   // wrap.style.transition = "all .3s ease;"
	}
	// function loaderDisplay2() {
	// 	if(visual) {
	// 		visual.classList.remove('hidden');
	// 	}
	// }
	function loaderDisplay3() {
		
		if(visual) {
			visual.classList.add('bg');
		}
	}
	function Displaynone() {
		wrap.style.display = "none"; 
	}
});